export default {
  SET_SESSION_CLASSES(state, array) {
    state.classes = array;
  },
  SET_CYCLE_LOGS(state, array) {
    state.cycle_logs = array;
  },
  SET_CLASS_STATUSES(state, array) {
    state.class_statuses = array;
  },
};



// WEBPACK FOOTER //
// ./src/store/classes/mutations.js